export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const FULL_SCREEN = 'FULL_SCREEN';
export const FULL_SCREEN_EXIT = 'FULL_SCREEN_EXIT';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

// actions.js
export const SET_BILLING_EMAIL = 'SET_BILLING_EMAIL';

export const setBillingEmail = (email) => {
    localStorage.setItem('billingEmail', email);  // Save to localStorage
    return {
        type: 'SET_BILLING_EMAIL',
        payload: email
    };
};
